import { createContext, RefObject } from "preact";

type HighlightableMenuItems = {
    [key: string]: HighlightableMenuItem;
};

type HighlightableMenuItem = {
    submenu: HighlightableMenuItems | null;
    ref: RefObject<HTMLElement>;
};

interface MenuContext {
    highlightables: HighlightableMenuItems;
    highlightedIndicesPath: string[];
    lastHighlightableOpen: boolean;
    keyboardNavigationIsActive: boolean;
    lastSubmenuPosition?: "right" | "left";
}

const MenuContext = createContext<MenuContext>({
    highlightables: {},
    highlightedIndicesPath: [],
    lastHighlightableOpen: false,
    keyboardNavigationIsActive: true
});

export default MenuContext;
export {
    HighlightableMenuItems,
    HighlightableMenuItem
};
